import "./Favorites.css";

export default function Favorites() {
  return (
    <div>
      <h1 className="favorites-main-heading">Favorites</h1>
    </div>
  );
}
